// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"cafbeaae","78":"14437bd1","130":"5c0832e0","234":"a5174088","283":"3c935bec","389":"b2f8fe5f","400":"fdae4b71","672":"ff4ae9b9","814":"71f2c37d"}[chunkId] + ".chunk.js";
};